import React, { useState, useContext, useEffect, useRef } from 'react';
import { submitForm } from '../components/utils/OutOfStockUtil';
import { OutOfStock } from './OutOfStock';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { getDomPath } from '@thd-olt-functional/utils';
import { MESSAGE_STATES, ITEM_TRACK_OOS_MESSAGE_EMAIL, ITEM_TRACK_OOS_MESSAGE_EMAIL_AND_TEXT } from './constants';

const TrackOutOfStock = ({ itemId, enableSms, legalDisclaimer }) => {

  const context = useContext(ExperienceContext);
  const ref = useRef();
  const statusRef = useRef([]);
  const [state, setState] = useState({
    status: 'init',
    loader: false
  });

  const updateState = (status, loader) => {
    setState((prevState) => ({
      ...prevState,
      loader,
      status
    }));
  };

  const handleOnSubmit = async ({ values }) => {
    statusRef.current = [];
    await submitForm(values, itemId, statusRef, context);
    const { loader, status } = statusRef?.current?.[0];
    updateState(status, loader);
  };

  const { status } = state;

  const trackError = (domPath) => {
    const message = MESSAGE_STATES[status]?.message;
    window.LIFE_CYCLE_EVENT_BUS.trigger('track-out-of-stock.click', { message, domPath });
  };

  useEffect(() => {
    if (['init', 'success', 'duplicate'].includes(status)) {
      return;
    }
    const _path = getDomPath(ref);
    trackError(_path);
  }, [status]);

  const oosMessageText = enableSms ? ITEM_TRACK_OOS_MESSAGE_EMAIL_AND_TEXT : ITEM_TRACK_OOS_MESSAGE_EMAIL;

  return (
    <OutOfStock
      enableSms={enableSms}
      legalDisclaimer={legalDisclaimer}
      handleOnSubmit={handleOnSubmit}
      status={status}
      updateState={updateState}
      buttonRef={ref}
      oosMessageText={oosMessageText}
    />);
};

TrackOutOfStock.displayName = 'TrackOutOfStock';

TrackOutOfStock.dataModel = {};

TrackOutOfStock.propTypes = {
  itemId: string,
  enableSms: bool,
  legalDisclaimer: string
};

TrackOutOfStock.defaultProps = {
  itemId: null,
  enableSms: false,
  legalDisclaimer: null
};

export { TrackOutOfStock };
